import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { ToasterService } from 'angular5-toaster';
import { EnhancedReview, ModerationStatus, UsingMode, IReviewComment, CommentPack, UserComment, AbstractEnhancedReview } from "../../core/review";
import { TramApiService } from "../../tram-api.service";
import { StorageService } from "../../storage.service";

import * as moment from 'moment';
import { User } from "../../core/user";
import { ReviewService } from "../../providers/review.service";
import { HttpErrorResponse } from "@angular/common/http";

@Component({
    selector: 'review',
    templateUrl: './review.component.html',
    styleUrls: ['./style.scss', './review.component.scss']
})
export class ReviewComponent implements OnInit {
    @Input() value: EnhancedReview;
    @Input() user: User;
    @Output() reviewRemoving = new EventEmitter<EnhancedReview>();

    ModerationStatus = ModerationStatus;
    UsingMode = UsingMode;

    comments: CommentPack[];
    mode: UsingMode = UsingMode.User;

    isLoading: boolean = false;

    isGodCommentFormOpened: boolean;
    isCommentFormOpened: boolean;
    isEditFormOpened: boolean;

    constructor(
        private storage: StorageService,
        private reviewService: ReviewService,
        private toaster: ToasterService) {
        storage.isSensitiveDataExist.subscribe(v => { this.init(v); });
    }

    ngOnInit() {
        this.init(this.storage.isSensitiveDataExist.value);
        this.initComments();
    }

    openGodCommentForm() {
        this.isGodCommentFormOpened = true;
    }
    onGodCommentFormClosed(e) {
        this.isGodCommentFormOpened = e;
    }

    tryOpenCommentForm(changeNameFormOpen) {
        if (this.user && !this.user.name)
            changeNameFormOpen();
        else
            this.isCommentFormOpened = true;
    }
    onChangeNameFormClosed(userName) {
        if (userName) {
            this.isCommentFormOpened = true;
        }
    }
    onCommentFormClosed(e) {
        this.isCommentFormOpened = e;
    }

    openEditForm() {
        this.isEditFormOpened = true;
    }
    onEditFormClosed(e) {
        this.isEditFormOpened = e;
    }

    onDeleteConfirmationClosed(e) {
        if (e && e.needToDelete === true) {
            this.isLoading = true;
            this.reviewRemoving.emit(this.value);
        }
    }

    onCommentRemoving(comment: CommentPack) {
        this.isLoading = true;
        this.reviewService
            .deleteComment(this.value, comment.comment)
            .then(() => {
                const index = this.value.comments.findIndex(c => c.comment.id === comment.comment.id);
                if (index >= 0) {
                    this.value.comments.splice(index, 1);
                }

                this.toaster.pop('success', null, 'Комментарий удален');
                this.isLoading = false;
            })
            .catch(error => this.handleError(error));
    }

    private init(isSensitiveDataExist: boolean) {
        if (isSensitiveDataExist && this.user) {
            if (this.user && this.user.isModerator) {
                this.mode = UsingMode.God;
            } else {
                this.mode = UsingMode.User;
            }
        } else {
            this.mode = UsingMode.Anonymous;
        }
    }

    private initComments() {
        if (!this.value || !this.value.comments.length)
            return;
        this.comments = [];
        const comments = this.value.comments;

        const id = this.user ? this.user.id : '';
        this.comments = this.mode === UsingMode.God
            ? comments
            : this.mode === UsingMode.User
                ? comments.filter(c => c.comment.status === ModerationStatus.Approved || c.comment.userId === id)
                : comments.filter(c => c.comment.status === ModerationStatus.Approved);
    }

    private handleError(error: HttpErrorResponse | string) {
        this.isLoading = false;
        if (error instanceof HttpErrorResponse) {
            this.toaster.pop('error', null, error.statusText);
        } else {
            this.toaster.pop('error', null, error);
        }
    }
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/review/review.component.ts